
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 2.5C4.944 2.5 2.5 5.012 2.5 8c0 3.056 2.444 5.5 5.5 5.5 2.988 0 5.5-2.444 5.5-5.5 0-2.988-2.512-5.5-5.5-5.5z","fill":"#9B84B8"}}),_c('path',{attrs:{"d":"M13 8h2M8 3V1M8 15v-2M1 8h2","stroke":"#9B84B8","stroke-width":"1.408","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"8","cy":"8","r":"2","fill":"#593289"}})])
          )
        }
      }
    